import { Command, CommandResult, ICommandResult } from '@/_core/cqrs/types/commands';

/**
 * Result of ChangeReleaseGoal command with conflict detection support.
 */
export interface ChangeReleaseGoalResult extends ICommandResult {
    /** The goal that was saved (on success). */
    SavedGoal?: string;
    /** True when a conflict was detected (goal changed since user started editing). */
    IsConflict?: boolean;
    /** The current goal in DB at time of conflict. */
    CurrentGoal?: string;
    /** The client baseline that triggered conflict (echoed back for UI). */
    OriginalGoal?: string;
    /** User ID of the last person who changed the goal. */
    LastAuthorUserId?: string;
    /** Display name of the last person who changed the goal. */
    LastAuthorName?: string;
    /** UTC timestamp of the last goal change. */
    LastChangedAtUtc?: string;
}

export class ChangeReleaseGoal extends Command<ChangeReleaseGoalResult> {
    public BoardActivity: any;

    public constructor(public StorymapId: string, public Id: string, public Goal: string, public OriginalGoal: string) {
        super('ChangeReleaseGoal');
    }
}

export class ChangeReleaseStatus extends Command<CommandResult> {
    public BoardActivity: any;

    public constructor(public StorymapId: string, public Id: string, public IsReleased: boolean) {
        super('ChangeReleaseStatus');
    }
}

export class ChangeReleaseStartDate extends Command<CommandResult> {
    public BoardActivity: any;

    public constructor(public StorymapId: string, public Id: string, public StartDate: Date | string) {
        super('ChangeReleaseStartDate');
    }
}

export class ChangeReleaseReleaseDate extends Command<CommandResult> {
    public BoardActivity: any;

    public constructor(public StorymapId: string, public Id: string, public ReleaseDate: Date | string) {
        super('ChangeReleaseReleaseDate');
    }
}

export class ChangeReleaseDates extends Command<CommandResult> {
    public BoardActivity: any;

    public constructor(public StorymapId: string, public Id: string, public StartDate: Date | string, public ReleaseDate: Date | string) {
        super('ChangeReleaseDates');
    }
}
